var swiper = new Swiper(".bunldeProducts", {
  slidesPerView: 4,
  spaceBetween: 16,
  navigation: {
    nextEl: ".bunldeProducts-button-next",
    prevEl: ".bunldeProducts-button-prev",
  },
  breakpoints: {
    0: {
      spaceBetween: 12,
      slidesPerView: 2.3,
    },
    749: {
      spaceBetween: 16,
      slidesPerView: 4,
    },
  },
});

document.addEventListener("DOMContentLoaded", () => {
  const button = document.querySelector(".custom-product-bundle__content-cards--button");

  if (!button) return;

  button.addEventListener("click", async () => {
    const items = [];

    const mainVariantId = button.dataset.mainVariantId;

    if (mainVariantId) {
      items.push({
        id: Number(mainVariantId),
        quantity: 1,
      });
    }

    const slides = document.querySelectorAll(".swiper-slide[data-variant-id]");

    slides.forEach((slide) => {
      const variantId = slide.dataset.variantId;

      if (!variantId) return;

      if (items.some((item) => item.id === Number(variantId))) return;

      items.push({
        id: Number(variantId),
        quantity: 1,
      });
    });

    if (!items.length) return;

    try {
      button.classList.add("loading");

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) {
        throw new Error("Add to cart failed");
      }

      const cartResponse = await fetch("/cart.js");
      const cartData = await cartResponse.json();

      document.dispatchEvent(
        new CustomEvent(ThemeEvents.cartUpdate, {
          detail: {
            data: {
              itemCount: cartData.item_count,
              source: "bundle",
            },
          },
        }),
      );
    } catch (error) {
      console.error(error);
    } finally {
      button.classList.remove("loading");
    }
  });
});
